import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 15" {...props}>
    <path
      d="m1.376 11.031-.27 2.404 2.359-.307 9.724-9.724-2.093-2.093-9.72 9.72zM10 3l2 2"
      fill="none"
      stroke="#919499"
      strokeWidth={1.04}
    />
  </svg>
);
const Memo = memo(SvgEdit);
export default Memo;
